import type { CoachingTimelineActor, CoachingTimelineEvent } from '@/lib/types';
import { outcomes } from './followupForm';
const relationships = { coach: 'Coach', assistant_coach: 'Assistant coach', guardian: 'Guardian', self: 'Player', unknown: 'Relationship unknown' };
export function actorLabel(actor: CoachingTimelineActor): string {
  return `${actor.display_name || 'Person unavailable'} · ${relationships[actor.relationship_at_time]}`;
}
export function occurrenceLabel(value: string | null | undefined, precision: 'day' | 'instant' | 'unknown' | null | undefined): string {
  if (!value || !precision || precision === 'unknown') return 'Occurrence time unknown';
  if (precision === 'day') return `Occurred on ${value.slice(0, 10)}`;
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? `Occurred ${date.toLocaleString()}` : 'Occurrence time unknown';
}
export function sourceOccurrenceLabel(value: string | null | undefined, precision: 'day' | 'instant' | 'unknown' | null | undefined): string {
  const label = occurrenceLabel(value, precision);
  return label === 'Occurrence time unknown' ? 'Source occurrence unknown' : `Source occurrence · ${label}`;
}
export function eventTimingLabel(event: CoachingTimelineEvent): string | null {
  const occurrence = occurrenceLabel(event.occurred_at, event.occurrence_precision);
  if (event.kind === 'observation_added' || event.kind === 'observation_corrected') return null;
  if (event.kind === 'followup_recorded') return occurrence === 'Occurrence time unknown' ? 'Follow-up occurrence unknown' : occurrence.replace(/^Occurred/, 'Follow-up occurrence');
  if (event.kind === 'coaching_action_approved') return occurrence === 'Occurrence time unknown' ? 'Action time unknown' : occurrence.replace(/^Occurred/, 'Action approved');
  return occurrence === 'Occurrence time unknown' ? 'Response time unknown' : occurrence.replace(/^Occurred/, 'Response reported');
}
export function orderedEvents(events: CoachingTimelineEvent[]): CoachingTimelineEvent[] {
  return [...events].sort((a, b) => a.event_id - b.event_id);
}
export function eventLabel(event: CoachingTimelineEvent): string {
  switch (event.kind) {
    case 'followup_recorded': return `Follow-up${event.outcome ? ` · ${outcomes[event.outcome]}` : ''}`;
    case 'coaching_action_approved': return 'Action approved';
    case 'observation_added': return 'Observation recorded';
    case 'observation_corrected': return 'Observation corrected';
    case 'response_baseline': return 'Earlier response';
    case 'response_changed': return 'Response changed';
    case 'response_submitted': return 'Response submitted';
  }
}
